import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { User, UserService, Profile } from "../../../../shared";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";

@Component({
  selector: "profile-card",
  templateUrl: "./profile-card.component.html",
  styleUrls: [
    "./profile-card.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class ProfileCardComponent implements OnInit {
  private defaultUserImg: string =
    "../../../../assets/images/uMuzi/african-mask.png";
  public currentUser: User;
  public isUser: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) {
    this.initializePNotify();
  }

  @Input() profile: Profile;
  @Output() onToggleFollowing = new EventEmitter<boolean>();

  ngOnInit() {
    this.compareProfileVSLoggedUser();
    this.onRouteChange();
  }

  public initializePNotify() {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }

  onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event) {
        this.compareProfileVSLoggedUser();
      }
    });
  }

  public compareProfileVSLoggedUser() {
    // first fetch data of profile being viewed
    this.route.data.subscribe((data: { profile: Profile }) => {
      this.profile = data.profile;
    });

    // then test if the logged in user is profile being viewed
    // Load the current user's data
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
      this.isUser = this.currentUser.username === this.profile.username;
    });
  }

  public setProfileFollowing() {
    this.route.data.subscribe((data: { profile: Profile }) => {
      this.onToggleFollowing.emit(!data.profile.isFollowing.following);
      this.notifyUser();
    });
  }

  public notifyUser() {
    PNotify.info({
      title: "Hey!",
      titleTrusted: false,
      text: this.profile.isFollowing.following
        ? "You are now following " + this.profile.username
        : "You are no longer following " + this.profile.username,
      textTrusted: false,
      icon: "fa fa-bell",
      Mobile: {
        swipeDismiss: true,
        styling: true,
      },
      width: "300px",
      delay: 3000,
      buttons: { closer: true, labels: { close: "Fechar", stick: "Manter" } },
      stack: {
        dir1: "down",
        firstpos1: 25,
      },
    });
  }
}
